import axios from "axios";

export const estado_suscripciones = async () => {
  const { data } = await axios.get("/api/admin/estado_suscripciones/");
  return data;
};

export const remover_colaborador = async (id) => {
  const { data } = await axios.post("/api/admin/remover_colaborador/", { id });
  return data;
};

export const activation_codes = async () => {
  const { data } = await axios.get("/api/admin/activation_codes/");
  return data;
};

export const create_activation_code = async (durationKey) => {
  const { data } = await axios.post("/api/admin/create_activation_code/", {
    durationKey,
  });
  return data;
};
